<div *ngIf="canAdd; else noAdd" class="flex flex-row justify-stretch items-start" [ngClass]="{
    'mt-4 w-full mx-auto lg:w-1/2 bg-green-50 border border-green-500 rounded pt-8 px-8 pb-2':
      !eposMode,
    'w-full  justify-start items-start': eposMode
  }">
  <mat-form-field appearance="fill" class="flex flex-col flex-grow basis-full flex-shrink">
    <mat-label>Search or scan barcode</mat-label>
    <input class="w-full" (keyup.enter)="attemptQuickAdd()" matInput data-cy="add-item-input"
      placeholder="Search or scan barcode" [formControl]="searchInput" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="handleOptionSelected($event)"
      [displayWith]="emptyDisplay">
      <mat-option *ngFor="let option of searchResults | async" [value]="option">
        <p>{{ option.name }}</p>
        <p class="text-gray-500 text-sm">{{ option.formatted_identifiers }}</p>
      </mat-option>
      @if (addFreetext) {
      <mat-option [value]="FREE_TEXT_ITEM" testId="add-freetext-item">
        Add a freetext item
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (showGridButton) {
  <button mat-icon-button (click)="openGrid()" class="flex-grow-0 flex-shrink-0 basis-auto">
    <mat-icon>grid_view</mat-icon>
  </button>
  }
  <button mat-icon-button (click)="openScanner()" [disabled]="_disabled" class="flex-grow-0 flex-shrink-0 basis-auto">
    <mat-icon>barcode_reader</mat-icon>
  </button>
</div>

<ng-template #noAdd>
  <div class="my-4 w-full text-center" data-cy="cannot-add-items">
    <p>
      <em>You cannot add items to this {{ parentType }}.</em>
    </p>
  </div>
</ng-template>